import { format, isDate } from 'date-fns';

type FormatDateToStringOptions = {
    detailed?: boolean;
};

export const formatDateToString = (
    date: Date | null,
    options: FormatDateToStringOptions = {}
) => {
    if (!date || !isDate(date)) return '-';

    try {
        return format(
            date,
            options.detailed ? 'dd.MM.yyyy HH:mm' : 'dd.MM.yyyy'
        );
    } catch (e) {
        console.error(e);
        return 'Ungültiges Datum';
    }
};

export const drawerValueToString = (value: unknown): string => {
    if (value === null || value === undefined) return '-';

    if (typeof value === 'string') return value;

    if (typeof value === 'boolean') return value ? 'Ja' : 'Nein';

    if (typeof value === 'number') return value.toString();

    if (isDate(value)) return formatDateToString(value as Date);

    return JSON.stringify(value);
};
